import { Close } from '@mui/icons-material'
import { IconButton, Modal as MuiModal } from '@mui/material'
import clsx from 'clsx'
import { ModalProps } from './@types'

export function Modal({
  head,
  open,
  onClose,
  children,
  className,
  ...props
}: ModalProps) {
  return (
    <MuiModal onClose={onClose} open={open} {...props}>
      <>
        <div className="absolute top-4 right-4">
          <IconButton color="inherit" size="small" onClick={onClose}>
            <Close />
          </IconButton>
        </div>

        <div
          className={clsx(
            'bg-backgroundHover rounded-xl overflow-auto grid gap-6 py-4 px-6 max-h-[86%] mx-auto w-[90%] md:max-w-[80%]',
            className,
            !className?.includes('lg:max-w-') && 'lg:max-w-[478px]',
          )}
        >
          <div className="w-max max-w-full mx-auto text-xl text-center font-bold">
            {head}
          </div>

          {children}
        </div>
      </>
    </MuiModal>
  )
}
